/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Talk_Feature_2Inputs */

const en_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participant muting & passcodes`)
};

const id_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membisukan peserta & kode pas`)
};

const ms_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senyapkan & kod laluan peserta`)
};

const ca_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silenciar participants i codis d'accés`)
};

const cs_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ztlumení účastníků a přístupové kódy`)
};

const da_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dæmpning af deltagere og adgangskoder`)
};

const de_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnehmer stummschalten & Passwörter`)
};

const et_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osalejate vaigistamine ja pääsukoodid`)
};

const es_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silenciar participantes y códigos de acceso`)
};

const fr_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise en sourdine et codes d’accès`)
};

const hr_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isključivanje zvuka sudionika i pristupne lozinke`)
};

const it_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password e disattivazione audio dei partecipanti`)
};

const lv_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dalībnieku skaņas izslēgšana un piekļuves kodi`)
};

const lt_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narių garso išjungimas ir prieigos kodai`)
};

const hu_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résztvevők némítása és jelszavak`)
};

const nl_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deelnemers dempen en toegangscodes`)
};

const nb_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passord og mikrofonstyring for deltakere`)
};

const pl_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyciszanie uczestników i kody dostępu`)
};

const pt_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Códigos de acesso e silenciar participantes`)
};

const ro_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dezactivarea microfonului și coduri de acces pentru participanți`)
};

const sk_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stlmenie účastníkov a prístupové kódy`)
};

const sl_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utišanje zvoka udeležencev in gesla`)
};

const fi_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osallistujien mykistys ja salasanat`)
};

const sv_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ljudavstängning av deltagare samt lösenord`)
};

const vi_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tắt tiếng người tham gia và mã truy cập`)
};

const tr_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katılımcıyı sessize alma ve şifreler`)
};

const el_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σίγαση συμμετεχόντων & κωδικοί πρόσβασης`)
};

const bg_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заглушаване на участниците и пароли`)
};

const ru_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отключение звука и коды доступа для участников`)
};

const sr_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Искључивање звука учесника и лозинке`)
};

const uk_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вимкнення звуку та паролі учасників`)
};

const ka_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მონაწილის ხმის გათიშვა და პაროლები`)
};

const hi_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पार्टिसिपेंट म्यूटिंग और पासकोड्स `)
};

const th_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การปิดเสียงผู้เข้าร่วมและรหัสผ่าน`)
};

const ko_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`참가자 음소거 및 암호`)
};

const zh_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参与者静音和密码`)
};

const zh_tw_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`與會者靜音功能及通行碼`)
};

const ja_talk_feature_2 = /** @type {(inputs: Talk_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加者のミュートとパスコード`)
};

/**
* | output |
* | --- |
* | "Participant muting & passcodes" |
*
* @param {Talk_Feature_2Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const talk_feature_2 = /** @type {((inputs?: Talk_Feature_2Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Talk_Feature_2Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_talk_feature_2(inputs)
	if (locale === "ms") return ms_talk_feature_2(inputs)
	if (locale === "ca") return ca_talk_feature_2(inputs)
	if (locale === "cs") return cs_talk_feature_2(inputs)
	if (locale === "da") return da_talk_feature_2(inputs)
	if (locale === "de") return de_talk_feature_2(inputs)
	if (locale === "et") return et_talk_feature_2(inputs)
	if (locale === "es") return es_talk_feature_2(inputs)
	if (locale === "fr") return fr_talk_feature_2(inputs)
	if (locale === "hr") return hr_talk_feature_2(inputs)
	if (locale === "it") return it_talk_feature_2(inputs)
	if (locale === "lv") return lv_talk_feature_2(inputs)
	if (locale === "lt") return lt_talk_feature_2(inputs)
	if (locale === "hu") return hu_talk_feature_2(inputs)
	if (locale === "nl") return nl_talk_feature_2(inputs)
	if (locale === "nb") return nb_talk_feature_2(inputs)
	if (locale === "pl") return pl_talk_feature_2(inputs)
	if (locale === "pt") return pt_talk_feature_2(inputs)
	if (locale === "ro") return ro_talk_feature_2(inputs)
	if (locale === "sk") return sk_talk_feature_2(inputs)
	if (locale === "sl") return sl_talk_feature_2(inputs)
	if (locale === "fi") return fi_talk_feature_2(inputs)
	if (locale === "sv") return sv_talk_feature_2(inputs)
	if (locale === "vi") return vi_talk_feature_2(inputs)
	if (locale === "tr") return tr_talk_feature_2(inputs)
	if (locale === "el") return el_talk_feature_2(inputs)
	if (locale === "bg") return bg_talk_feature_2(inputs)
	if (locale === "ru") return ru_talk_feature_2(inputs)
	if (locale === "sr") return sr_talk_feature_2(inputs)
	if (locale === "uk") return uk_talk_feature_2(inputs)
	if (locale === "ka") return ka_talk_feature_2(inputs)
	if (locale === "hi") return hi_talk_feature_2(inputs)
	if (locale === "th") return th_talk_feature_2(inputs)
	if (locale === "ko") return ko_talk_feature_2(inputs)
	if (locale === "zh") return zh_talk_feature_2(inputs)
	if (locale === "zh-tw") return zh_tw_talk_feature_2(inputs)
	if (locale === "ja") return ja_talk_feature_2(inputs)
	return en_talk_feature_2(inputs)
});